import { UIValue } from '../ui/types';
import { YPaymentCurrency } from '../y/amount';
import { YCountryId } from '../y/types';
import { getCountry } from '../me/me';

export function cCountryGetValues(): UIValue<YCountryId>[] {
    return [{ key: 'SE', name: 'Sweden' }, { key: 'DE', name: 'Germany' }]
}

export function cCountryDefaultCurrency(country: YCountryId): YPaymentCurrency {
    switch(country) {
        case 'SE': return 'SEK';
        default: return 'EUR';
    }
}

export function cGetDefaultCurrency(): YPaymentCurrency {
    return cCountryDefaultCurrency(getCountry());
}
